const el = {
  dropdown: document.querySelector('.product-info__trade-in-example-dropdown'),
  example: document.querySelector('.product-info__trade-in-example-container'),
  dropdownItems: document.querySelectorAll(
    '.product-info__trade-in-example-dropdown-item'
  ),
}

export const ProductTradeIn = {
  init: () => {
    if (el.dropdown) {
      el.example.addEventListener('click', ProductTradeIn.DropDownActive)
    }
    if (el.dropdownItems.length > 0) {
      el.dropdownItems.forEach((item) => {
        // Add your event listener here
        item.addEventListener('click', ProductTradeIn.DropDownItemClick)
      })
    }
  },
  DropDownActive: () => {
    el.dropdown.classList.toggle('active')
  },
  DropDownItemClick: (event: Event) => {
    const clickedItem = event.currentTarget as HTMLElement

    // Toggle the 'active' class on the dropdown
    el.dropdown.classList.toggle('active')

    // Swap image sources
    const mainImage = el.example.querySelector<HTMLImageElement>('.main-image')
    const clickedImage = clickedItem.querySelector<HTMLImageElement>('.dropdown-image')

    if (mainImage && clickedImage) {
      const tempSrc = mainImage.src
      mainImage.src = clickedImage.src
      clickedImage.src = tempSrc
    }

    // Swap product names
    const mainProductName = el.example.querySelector<HTMLParagraphElement>(
      '.product-info__trade-in-example-productName'
    )
    const clickedProductName = clickedItem.querySelector<HTMLParagraphElement>(
      '.product-info__trade-in-example-productName'
    )

    if (mainProductName && clickedProductName) {
      const tempName = mainProductName.innerHTML
      mainProductName.innerHTML = clickedProductName.innerHTML
      clickedProductName.innerHTML = tempName
    }

    // Swap product texts
    const mainProductText =
      el.example.querySelector<HTMLHeadingElement>('.main-product-text')
    const clickedProductText =
      clickedItem.querySelector<HTMLHeadingElement>('.main-product-text')

    if (mainProductText && clickedProductText) {
      const tempText = mainProductText.innerHTML
      mainProductText.innerHTML = clickedProductText.innerHTML
      clickedProductText.innerHTML = tempText
    }
  },
}
